module.exports = __webpack_public_path__ + "img/cnpee_nou22.acd53821.png";